// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3dAbQ","left":"StickyBox_left__3T184","right":"StickyBox_right__1ztyr"};